import { BaseProject } from './project';

export type ProjectVisibility = 'private' | 'team' | 'link';

export function isAllowPublic(projectVisibility: ProjectVisibility): boolean {
  return projectVisibility === 'link';
}

export function getProjectVisibilityType(project?: BaseProject | null): ProjectVisibility {
  if (!project) {
    return 'private';
  }

  if (project.allow_public) {
    return 'link';
  } else if (project.team) {
    return 'team';
  } else {
    return 'private';
  }
}
